module.exports = __webpack_public_path__ + "static/media/points8_7.be21f115.png";